import "@/i18n";
import "@/App.css";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import Maintenance from "@/pages/Maintenance";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { ContentProvider } from "@/context/ContentContext";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import MyOrders from "@/pages/MyOrders";
import Revue from "@/pages/Revue";
import Article from "@/pages/Article";
import VIP from "@/pages/VIP";
import { Toaster } from "@/components/ui/sonner";

function MaintenanceGate({ children }) {
  const location = useLocation();
  const [enabled, setEnabled] = useState(null);

  useEffect(() => {
    api
      .get("/settings/maintenance")
      .then((r) => setEnabled(!!r.data.enabled))
      .catch(() => setEnabled(false));
  }, []);

  if (enabled === null) return null;
  if (enabled && !location.pathname.startsWith("/admin")) return <Maintenance />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <ContentProvider>
              <MaintenanceGate>
                <Header />
                <main>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/boutique" element={<Catalog />} />
                    <Route path="/categorie/:category" element={<Catalog />} />
                    <Route path="/produit/:id" element={<ProductDetail />} />
                    <Route path="/panier" element={<Cart />} />
                    <Route path="/commande" element={<Checkout />} />
                    <Route path="/commande/succes" element={<CheckoutSuccess />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/mes-commandes" element={<MyOrders />} />
                    <Route path="/maison" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/revue" element={<Revue />} />
                    <Route path="/revue/:slug" element={<Article />} />
                    <Route path="/vip" element={<VIP />} />
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route path="/admin" element={<AdminDashboard />} />
                  </Routes>
                </main>
                <Footer />
                <Toaster />
              </MaintenanceGate>
            </ContentProvider>
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
